import {
  type SearchRetailerRolesQuery,
  useSearchRetailerRolesQuery,
} from 'domains/role-management/api'

export type Role = SearchRetailerRolesQuery['roleSearch'][0]

export const useGetRole = ({ roleId, skip = false }) => {
  // TODO replace with a more optimal fetch
  const { data, loading, error, refetch } = useSearchRetailerRolesQuery({
    fetchPolicy: 'cache-and-network',
    skip,
  })

  const role = !loading && !error && data?.roleSearch?.find(role => role.id === roleId)

  return { role, loading, error, refetch }
}
